<template>
  <div>
    <section class="main" id="mainBox">
      <div class="top">
        <div class="nav">
          <li
            v-bind:class="activeClass == index ? 'active' : ''"
            v-for="(item, index) in navList"
            :key="index"
            @click="getItem(index)"
          >
            {{ item.name }}
          </li>
        </div>
      </div>

      <div class="content">
        <!-- 发展历程 -->
        <div class="contentBox" v-show="visible1">
          <div class="aboutMid">
            <div class="about1">
              <div class="version-time">
                <img v-lazy="img1" />
              </div>
            </div>
          </div>
        </div>

        <!-- 愿景使命 -->
        <div class="contentBox" v-show="visible2">
          <div class="aboutMid">
            <div class="about2">
              <div class="about3">
                <div class="version-time">
                  <p class="p0">愿景</p>
                  <p class="p1">以异构计算连接需求和最优算法</p>
                  <p class="p1">以具有绝对优势的产品赢得客户的信赖</p>
                </div>
                <div class="version-time">
                  <p class="p0">使命</p>
                  <p class="p1">成为公司五年内建成世界一流企业的核心动力</p>
                  <p class="p2">
                    ➤ 洞察技术发展趋势，通过参加行业组织和会议，发掘增量市场的机会点，进行创新、灰黑色引领技术和AI技术的预研、行业推广以及标准制定，为公司创造新的增长点。
                  </p>
                  <p class="p2">
                    ➤ 跟随数字化芯片、AI技术发展的浪潮，利用13年努力构建的产品芯片化设计、AI智能制造、客户服务体系，从客户需求驱动产品需求，从产品需求驱动芯片需求，打造具有创新优势的产品。
                  </p>
                </div>
              </div>
              <div class="version-time3">
                <img v-lazy="img2" />
              </div>
            </div>
          </div>
        </div>

        <!-- 研发团队 -->
        <div class="contentBox" v-show="visible3">
          <div class="aboutMid">
            <div class="about1">
              <p>
                鼎信通讯于2008年由18人核心团队创立，芯片理论研究院随后成立，以工匠精神持续追求卓越和专业精深，开启了引领企业跨越式发展的征程。
              </p>
              <p>
                鼎信建立了青岛、上海、西安三大芯片研发中心，团队总人数约200人，成员全部具有本科以上学历，其中博士后1名、博士3人，硕士50余人，985/211占比超过80%。下设算法与数字设计、模拟设计、后端与版图部、系统验证部、应用工程、平台研发、AI技术与实现7个二级部门，成立创新技术推广部三级部门，涵盖AI技术、芯片设计、验证、测试、应用研发等芯片和产品设计全流程，具有从客户需求—芯片设计—应用产品孵化的技术能力和完善的研发体系。
              </p>
              <p>
                先后与华北电力大学、中国石油大学、东北大学等近十余所高校共建产学研基地、博士后工作站、人工智能联合实验室，从高校获取最新的技术理论知识，并以成功的工程项目实践反哺高校，让学生深入参与实际项目，从中获取实践经验，培养理论与实际相结合的创新型人才；为行业的发展壮大培养和输送更多更好的人才。
              </p>
              <div class="version-time2">
                <img v-lazy="img3" class="nImg" />
                <img v-lazy="img4" class="nImg" />
                <img v-lazy="img5" class="nImg" />
              </div>
              <p>
                2021年12月3日，鼎信通讯AI智能博士后科研工作站成立后引进首位博士后。鼎信AI智能博士后工作站建设工作顺利起步，说明了政府、行业对于鼎信雄厚研发实力的认可，并进一步凸现了芯片及基础理论研究院的高水平科研能力，AI智能芯片化实现的理念已经被东北大学教育部首批人工智能专业教授认可。以AI智能和探测结合的智能化探测解决方案，必将推动研究院成功成为世界一流的AI智能芯片化解决方案的引领者。
              </p>
              <div class="version-time2">
                <img v-lazy="img6" class="nImg" />
                <img v-lazy="img7" class="nImg" />
                <img v-lazy="img8" class="nImg" />
              </div>
            </div>
          </div>
        </div>

        <!-- 研发体系 -->
        <div class="contentBox" v-show="visible4">
          <div class="aboutMid">
            <div class="about1">
              <p>
                芯片研发团队和产品线协同开发的矩阵化项目制的模式，从需求->分析->设计->开发->测试->验证->上市的高效芯片开发流程。已经创建了严谨科学的由芯片开发引领产品优势的管理体系架构。
              </p>
              <div class="version-time2">
                <img v-lazy="img9" class="lImg" />
                <img v-lazy="img10" class="rImg" />
              </div>
              <p>
                实现了从芯片复制到产品复制的跨越，并在电力和消防行业取得了商业成功。这套高强度技术投入驱动大规模自动化生产的模式也必将复制到其他行业和领域，成为鼎信通讯五年内建成世界一流企业的核心动力。
              </p>
              <div class="version-time1">
                <img v-lazy="img11" />
              </div>
              <p>
                公司为客户提供从研发到生产制造的一站式服务，包括精密模组和整机产品在内的产品解决方案。芯片设计—产品研发—智能制造的垂直一体化整合供应链带来巨大的优势：
              </p>
              <p class="p1">➤ 保护巨额经费研发的原创技术走的更远</p>
              <p class="p1">➤ 推动高技术产品的加速落地</p>
              <p class="p1">➤ 获取全产业链超额收益</p>
              <div class="version-time1">
                <img v-lazy="img12" />
              </div>
            </div>
          </div>
        </div>

        <!-- 研发成果 -->
        <div class="contentBox" v-show="visible5">
          <div class="aboutMid">
            <div class="about1">
              <p>
                2009年，公司原始股东研发成功窄带载波通信芯片TCC系列，公司业绩迅速增长。目前该系列芯片全球在网运行量约2.5亿片，涵盖美洲、非洲、中亚、东南亚等全球多个区域，其窄带芯片和窄带模组实现总利润超20多亿，完成了公司资本的原始积累，一举奠定了公司高速发展的基础。
              </p>
              <p>
                鼎信芯片研发定位于物联网、智能传感、计量测量、电源功率器件等方向，主要从事高速、高性能、低功耗Soc芯片设计。目前已经上市了开关电源类芯片、窄带载波芯片、单相电表主控芯片以及AFDD主控芯片等等，开发了1GHz高速ADC、2.4GHz锁相环、高速高增PGA、高速红外烟感、电弧AI处理等专用IP模块。
              </p>
              <p>
                目前公司所产的智能电能表应用的MCU芯片、计量芯片、485通信芯片、开关电源芯片、LDO、负荷开关控制芯片等所有芯片均实现鼎信自主化设计和定制，具备5000万只的年产能及供货能力；所研制的消防二线制芯片，推动了消防行业的通讯革命，为国家节约大量线缆，使二线制成为消防行业事实上的标准，更让鼎信消防迅速从零成长为国内前五大消防公司。
              </p>
              <div class="version-time">
                <img v-lazy="img13" />
              </div>
              <p class="p4">
                公司自研芯片内销金额逐年大幅增长，自2013年至今增长了近200倍，2021年达3.6亿，有力地支撑了公司业务的强劲发展。
              </p>
              <div class="version-time1">
                <img v-lazy="img14" />
              </div>
            </div>
          </div>
        </div>

        <!-- 设计理念 -->
        <div class="contentBox" v-show="visible6">
          <div class="aboutMid">
            <div class="about1">
              <div class="aboutContent">
                <div class="div1">
                  <div class="div2">
                    <img v-lazy="img15" />
                  </div>
                  <div class="div3">
                    <p class="p1">需求—方案—芯片</p>
                    <p class="p2">
                      根据用户需求场景，确定技术解决方案，匹配最优算法，定制化芯片设计。需求—方案—芯片设计一体化的公司才有能力从规划到产品实现快速迭代、问题解决，最终构建产品的强大竞争力。
                    </p>
                  </div>
                </div>
                <div class="div1">
                  <div class="div2">
                    <img v-lazy="img16" />
                  </div>
                  <div class="div3">
                    <p class="p1">算法定义芯片</p>
                    <p class="p2">
                      在芯片设计之初就要考虑在其上主要运行什么样的算法，而软件算法的设计也会根据芯片的基础架构进行相应的优化升级，从而最大程度上释放芯片和软件算法所带来的计算能力。
                    </p>
                  </div>
                </div>
              </div>
              <div class="aboutContent" style="margin-top: 50px">
                <div class="div1">
                  <div class="div2">
                    <img v-lazy="img17" />
                  </div>
                  <div class="div3">
                    <p class="p1">AI+异构计算</p>
                    <p class="p2">
                      传统的SoC芯片加上人工智能算法专用加速的芯片一起形成一个完整的异构计算系统。专用算法模块在对功耗和体积要求严格的应用场合具有绝对优势，特别适应于前端小空间微功耗产品。
                    </p>
                  </div>
                </div>
                <div class="div1">
                  <div class="div2">
                    <img v-lazy="img18" />
                  </div>
                  <div class="div3">
                    <p class="p1">算力即产品力</p>
                    <p class="p2">
                      自2012年以来，图像、语音、机器视觉和游戏等领域的数据呈现爆发性增长，数字增长速度为每3.5个月翻一倍，期间人们对于算力的需求增长了超过30万倍，硬件算力的提升将成为产品制胜的关键。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 宣传视频 -->
        <div class="videoBox" v-show="visible7">
          <div class="videoContent">
            <DisplayVideo ref="myVideo" />
          </div>
        </div>

        <!-- 加入我们 -->
        <div class="contentBox" v-show="visible8">
          <div class="aboutMid">
            <div class="about1">
              <table width="100%" class="cpgnTb" cellpadding="">
                <tr>
                  <td v-on:click="gangwei1">
                    <dl>
                      <dt>数字IC设计工程师</dt>
                      <dd>需求人数：10人</dd>
                    </dl>
                  </td>
                  <td v-on:click="gangwei2">
                    <dl>
                      <dt>模拟IC设计工程师</dt>
                      <dd>需求人数：4人</dd>
                    </dl>
                  </td>
                  <td v-on:click="gangwei9">
                    <dl>
                      <dt>数字后端设计工程师</dt>
                      <dd>需求人数：2人</dd>
                    </dl>
                  </td>
                </tr>
                <tr>
                  <td v-on:click="gangwei3">
                    <dl>
                      <dt>FPGA应用工程师</dt>
                      <dd>需求人数：3人</dd>
                    </dl>
                  </td>
                  <td v-on:click="gangwei4">
                    <dl>
                      <dt>量产测试工程师</dt>
                      <dd>需求人数：1人</dd>
                    </dl>
                  </td>
                  <td v-on:click="gangwei5">
                    <dl>
                      <dt>数字验证工程师</dt>
                      <dd>需求人数：3人</dd>
                    </dl>
                  </td>
                </tr>
                <tr>
                  <td v-on:click="gangwei6">
                    <dl>
                      <dt>系统应用工程师</dt>
                      <dd>需求人数：2人</dd>
                    </dl>
                  </td>
                  <td v-on:click="gangwei7">
                    <dl>
                      <dt>软件工程师</dt>
                      <dd>需求人数：2人</dd>
                    </dl>
                  </td>
                  <td v-on:click="gangwei8">
                    <dl>
                      <dt>硬件工程师</dt>
                      <dd>需求人数：2人</dd>
                    </dl>
                  </td>
                </tr>
              </table>
              <p class="p4">
                青岛研发中心：青岛市高新区华贯路858号 青岛鼎信通讯科技产业园
              </p>
              <p class="p4">上海研发中心：上海市浦东新区碧波路572弄115号11幢</p>
              <p class="p4">Email：hr@topscomm.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <job ref="job" />
  </div>
</template>

<script>
import DisplayVideo from "./components/DisplayVideo.vue";
import Job from "./components/Job.vue";

export default {
  name: "app",
  components: {
    DisplayVideo,
    Job,
  },
  data() {
    return {
      visible1: true,
      visible2: false,
      visible3: false,
      visible4: false,
      visible5: false,
      visible6: false,
      visible7: false,
      visible8: false,
      img1: {
        src: require("./assets/licheng2022.png"),
      },
      img2: {
        src: require("./assets/yuanjing.jpg"),
      },
      img3: {
        src: require("./assets/xuexiao1.png"),
      },
      img4: {
        src: require("./assets/xuexiao2.jpg"),
      },
      img5: {
        src: require("./assets/xuexiao3.png"),
      },
      img6: {
        src: require("./assets/chanxueyan1.png"),
      },
      img7: {
        src: require("./assets/chanxueyan2.png"),
      },
      img8: {
        src: require("./assets/chanxueyan3.png"),
      },
      img9: {
        src: require("./assets/tixi1.png"),
      },
      img10: {
        src: require("./assets/tixi2.png"),
      },
      img11: {
        src: require("./assets/tixi3.png"),
      },
      img12: {
        src: require("./assets/tixi4.png"),
      },
      img13: {
        src: require("./assets/chengguo.png"),
      },
      img14: {
        src: require("./assets/xiaoe.png"),
      },
      img15: {
        src: require("./assets/linian1.jpeg"),
      },
      img16: {
        src: require("./assets/linian2.png"),
      },
      img17: {
        src: require("./assets/linian3.png"),
      },
      img18: {
        src: require("./assets/linian4.png"),
      },
      activeClass: 0,
      navList: [
        { name: "发展历程" },
        { name: "愿景使命" },
        { name: "研发团队" },
        { name: "研发体系" },
        { name: "研发成果" },
        { name: "设计理念" },
        { name: "宣传视频" },
        { name: "加入我们" },
      ],
    };
  },
  mounted() {
    var elementResizeDetectorMaker = require("element-resize-detector"); //导入
    // 创建实例
    var erd = elementResizeDetectorMaker();
    //监听id为test的元素 大小变化
    erd.listenTo(document.getElementById("mainBox"), function (element) {
      var height = element.offsetHeight;
      window.parent.postMessage(
        {
          type: "message-1",
          body: {
            height: height,
          },
        },
        "*"
      );
    });
  },
  methods: {
    getItem: function (index) {
      this.activeClass = index;
      switch (index) {
        case 0: {
          this.$refs.myVideo.stopVideo();
          this.visible1 = true;
          this.visible2 = false;
          this.visible3 = false;
          this.visible4 = false;
          this.visible5 = false;
          this.visible6 = false;
          this.visible7 = false;
          this.visible8 = false;
          break;
        }
        case 1: {
          this.$refs.myVideo.stopVideo();
          this.visible1 = false;
          this.visible2 = true;
          this.visible3 = false;
          this.visible4 = false;
          this.visible5 = false;
          this.visible6 = false;
          this.visible7 = false;
          this.visible8 = false;
          break;
        }
        case 2: {
          this.$refs.myVideo.stopVideo();
          this.visible1 = false;
          this.visible2 = false;
          this.visible3 = true;
          this.visible4 = false;
          this.visible5 = false;
          this.visible6 = false;
          this.visible7 = false;
          this.visible8 = false;
          break;
        }
        case 3: {
          this.$refs.myVideo.stopVideo();
          this.visible1 = false;
          this.visible2 = false;
          this.visible3 = false;
          this.visible4 = true;
          this.visible5 = false;
          this.visible6 = false;
          this.visible7 = false;
          this.visible8 = false;
          break;
        }
        case 4: {
          this.$refs.myVideo.stopVideo();
          this.visible1 = false;
          this.visible2 = false;
          this.visible3 = false;
          this.visible4 = false;
          this.visible5 = true;
          this.visible6 = false;
          this.visible7 = false;
          this.visible8 = false;
          break;
        }
        case 5: {
          this.$refs.myVideo.stopVideo();
          this.visible1 = false;
          this.visible2 = false;
          this.visible3 = false;
          this.visible4 = false;
          this.visible5 = false;
          this.visible6 = true;
          this.visible7 = false;
          this.visible8 = false;
          break;
        }
        case 6: {
          this.$refs.myVideo.initVideo();
          this.visible1 = false;
          this.visible2 = false;
          this.visible3 = false;
          this.visible4 = false;
          this.visible5 = false;
          this.visible6 = false;
          this.visible7 = true;
          this.visible8 = false;
          break;
        }
        case 7: {
          this.$refs.myVideo.stopVideo();
          this.visible1 = false;
          this.visible2 = false;
          this.visible3 = false;
          this.visible4 = false;
          this.visible5 = false;
          this.visible6 = false;
          this.visible7 = false;
          this.visible8 = true;
          break;
        }
      }
    },
    gangwei1() {
      this.$refs.job.setVisible(1);
    },
    gangwei2() {
      this.$refs.job.setVisible(2);
    },
    gangwei3() {
      this.$refs.job.setVisible(3);
    },
    gangwei4() {
      this.$refs.job.setVisible(4);
    },
    gangwei5() {
      this.$refs.job.setVisible(5);
    },
    gangwei6() {
      this.$refs.job.setVisible(6);
    },
    gangwei7() {
      this.$refs.job.setVisible(7);
    },
    gangwei8() {
      this.$refs.job.setVisible(8);
    },
    gangwei9() {
      this.$refs.job.setVisible(9);
    },
  },
};
</script>

<style>
body {
  padding: 0px;
  margin: 0px;
  background: #fff;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
}

.main {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: block;
}

.top {
  position: relative;
}

.nav {
  display: flex;
  height: 80px;
  line-height: 80px;
  text-align: center;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #dddddd;
  justify-content: center;
}

.nav li {
  flex: 1;
  color: #3d3b3b;
  display: inline-block;
  font-size: 18px;
  text-align: center;
  height: 60px;
  line-height: 80px;
  max-width: 80px;
  cursor: pointer;
  margin: 0 25px;
}

.nav .active {
  color: #ee1b24;
  border-bottom: 3px solid #ee1b24;
}

.content {
  background: white;
}

.contentBox {
  padding-top: 50px;
}

.videoBox {
  padding-top: 60px;
}

.videoContent {
  width: 960px;
  margin: 0 auto;
}

.aboutMid {
  margin: 0 auto;
}

.about1 {
  position: relative;
}

.about1 p {
  font-size: 16px;
  color: #000;
  line-height: 32px;
  text-indent: 32px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.about1 .p1 {
  font-size: 16px;
  color: #000;
  line-height: 32px;
  text-indent: 32px;
}

.about1 .p4 {
  font-size: 16px;
  color: #000;
  line-height: 32px;
  font-weight: normal;
  text-align: center;
  margin: 0 auto;
  text-indent: 0px;
}

.about1 .version-time {
  margin: 0 auto;
}

.about1 .version-time img {
  width: 100%;
}

.about1 .version-time1 {
  margin: 24px auto 24px auto;
}

.about1 .version-time1 img {
  width: 100%;
}

.about1 .version-time2 {
  margin: 24px auto 24px auto;
  justify-content: center;
  display: flex;
}

.about1 .version-time2 .lImg {
  width: 25%;
  margin-right: 80px;
}

.about1 .version-time2 .rImg {
  width: 25%;
  margin-left: 80px;
}

.about1 .version-time2 .nImg {
  width: 30%;
  margin-left: 10px;
  margin-right: 10px;
}

.about1 .aboutContent {
  margin-top: 10px;
  justify-content: center;
  display: flex;
}

.about1 .aboutContent .div1 {
  width: 50%;
}

.about1 .aboutContent .div2 {
  width: 100%;
  text-align: center;
}

.about1 .aboutContent .div2 img {
  width: 50%;
}

.about1 .aboutContent .div3 {
  width: 80%;
  margin: 0 auto;
}

.about1 .aboutContent .p1 {
  font-size: 20px;
  color: #000;
  line-height: 26px;
  font-weight: normal;
  text-align: center;
  margin-top: 25px;
  text-indent: 0px;
}

.about1 .aboutContent .p2 {
  font-size: 16px;
  color: #000;
  line-height: 28px;
  font-weight: normal;
  text-align: center;
  margin-top: 25px;
  text-indent: 0px;
}

.about2 .p1 {
  font-size: 18px;
  color: #222222;
  line-height: 40px;
  margin: 0 auto;
  margin-top: 15px;
}

.about2 .p2 {
  font-size: 16px;
  color: #222222;
  line-height: 32px;
  margin: 0 auto;
  margin-top: 10px;
  margin-left: 55px;
  max-width: 560px;
}

.about2 .version-time1 {
  margin: 0 auto;
}

.about2 .version-time1 img {
  width: 100%;
  margin-top: 40px;
  margin-bottom: 20px;
}

.about2 .version-time2 {
  margin-left: 60px;
}

.about2 .version-time3 {
  margin: 0 auto;
  text-align: center;
}

.about2 .version-time3 img {
  width: 88%;
  margin-top: 30px;
  margin-bottom: 20px;
}

.about3 {
  justify-content: center;
  display: flex;
}

.about3 .version-time {
  margin: 0 auto;
}

.about3 .p0 {
  font-size: 18px;
  color: #222222;
  line-height: 24px;
  margin: 0 auto;
  margin-top: 15px;
  margin-bottom: 30px;
}

.about3 .p0::after {
  content: "";
  display: block;
  height: 2px;
  background: #ee1b24;
  width: 35px;
  margin-top: 10px;
}

.about3 .p1 {
  font-size: 20px;
  color: #222222;
  line-height: 24px;
  margin: 0 auto;
  margin-top: 15px;
  font-weight: bold;
}

.about3 .p2 {
  font-size: 14px;
  color: #222222;
  line-height: 28px;
  margin: 0 auto;
  margin-top: 10px;
  max-width: 560px;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  margin-top: 10px;
  margin-bottom: 45px;
}

.cpgnTb td {
  padding: 0;
}

.cpgnTb td {
  width: 33%;
  border: 1px solid #e9e9e9;
  padding: 40px 60px;
}

.cpgnTb td:hover {
  cursor: pointer;
  color: #fff;
  background-color: #ee1b24;
  transform: scale(1.06);
}

.cpgnTb td dt {
  font-size: 20px;
  line-height: 25px;
  margin-bottom: 8px;
  margin-left: 0px;
}

.cpgnTb td dd {
  font-size: 16px;
  line-height: 20px;
  margin-left: 0px;
}

img[lazy="loaded"] {
  animation: appear 0.3s;
  animation-fill-mode: both;
}
@keyframes appear {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>
